export default {"src":"/_next/static/media/globe.afe29362.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};